import Vue from '../vue/common/vue-common';
import CollapsedContent from '../vue/components/common/container/CollapsedContent';

const elements = cr$.byClass('collapsed-vue');

requestIdleCallback(() => {
    elements.each((el) => {
        new Vue({
            el,
            components: { CollapsedContent },
        });
    });
});
